<template>
  <v-form ref="cardForm" v-model="valid">
    <div style="height: 500px; width: 100%" :id="'mapCard'+id">
      <l-map
        ref="map"
        v-if="showMap"
        :zoom="zoom"
        :center="center"
        :options="mapOptions"
        style="height: 100%"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        @click="addMarker"
      >
        <l-tile-layer
          :url="url"
          :attribution="attribution"
        />
        <l-geosearch :options="geoSearchOptions"></l-geosearch>
        <l-marker v-if="marker!=null" :lat-lng="marker" @click="removeMarker(index)">
          <!--<l-tooltip :content="tooltipContent" :options="{ permanent: true }" />-->
        </l-marker>
      </l-map>
    </div>
  </v-form>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import LGeosearch from "vue2-leaflet-geosearch";
import { icon } from "leaflet";
import "leaflet-geosearch/dist/geosearch.css";

// eslint-disable-next-line  
delete L.Icon.Default.prototype._getIconUrl  
// eslint-disable-next-line  
L.Icon.Default.mergeOptions({  
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),  
  iconUrl: require('leaflet/dist/images/marker-icon.png'),  
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')  
})

export default {
  name: "Example",
  components: {
    LMap,
    LTileLayer,
    LGeosearch,
    LMarker
  },
  props:{
    id:{
      type:String
    },
    cardTitle: {
      type: String,
      default: ''
    },
    preRegisteredValues: {
      type:Object
    }
  },
  data() {
    return {
      valid: false,
      zoom: 13,
      center: latLng(-34.92185683185205, -57.954678492025124),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentZoom: 11.5,
      currentCenter: latLng(-34.92185683185205, -57.954678492025124),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5
      },
      showMap: true,
      geoSearchOptions: {
        provider: new OpenStreetMapProvider(),
        showMarker: false,
        autoClose: true
      },
      marker:null,
      icon: icon({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
      }),
      position: {},
    };
  },
  mounted() {
    this.getUserPosition();
    this.$refs.map.mapObject.on("geosearch/showlocation", this.onSearch);
    if(this.preRegisteredValues !== undefined){
      this.marker = {lat:this.preRegisteredValues.geoLocation[0].y, lng:this.preRegisteredValues.geoLocation[0].x}
    }
  },
  watch: {
    position: {
      deep: true,
      async handler(value) {
        this.address = await this.getAddress();
        this.$emit("input", { position: value, address: this.address });
      }
    }
  },
  methods: {
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    removeMarker() {
      this.marker= null;
    },
    addMarker(event) {
      this.marker = event.latlng;
    },
    async getAddress() {
      this.loading = true;
      let address = "Unresolved address";
      try {
        const { lat, lng } = this.position;
        const result = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lng}`
        );
        if (result.status === 200) {
          const body = await result.json();
          address = body.display_name;
        }
      } catch (e) {
        console.error("Reverse Geocode Error->", e);
      }
      this.loading = false;
      return address;
    },
    onSearch(value) {
      const loc = value.location;
      this.position = { lat: loc.y, lng: loc.x };
    },
    async getUserPosition() {
      if (navigator.geolocation) {
        // get GPS position
        navigator.geolocation.getCurrentPosition(pos => {
          // set the user location
          this.userLocation = {
            lat: pos.coords.latitude,
            lng: pos.coords.longitude
          };
        });
      }
    },
    emitCardInfo(){
      this.$refs.cardForm.validate()
      if(this.valid){
        var event = 'getCardInfo'
        var card={
          name: this.cardTitle,
          cardType: 4
        }
        if(this.$route.params.id && this.preRegisteredValues !== undefined){
          if(this.preRegisteredValues.geoLocation[0].y !== this.marker.lat || this.preRegisteredValues.geoLocation[0].x !== this.marker.lng) {
            card.geoLocation= [this.marker.lng, this.marker.lat] 
          }
          card.projectCardId= this.preRegisteredValues.projectCardId
        } else {
          card.geoLocation= [this.marker.lng, this.marker.lat] 
        }
        this.$emit(event, card)
      }
    }
  }
};
</script>